import { Link } from 'react-router-dom';
function Footer() {
    return (
        <footer className="pc-footer">
            <div className="footer-wrapper container-fluid">
                <div className="row">
                    <div className="col my-1">
                        <p className="m-0"
                        >PayServe &#9829; copyright</p>
                    </div>
                   
                </div>
            </div>
        </footer>

    )
}
export default Footer